export enum ActionType {
	ADD = 'ADD_TO_CART',
	REMOVE = 'REMOVE_FROM_CART',
	LOAD = 'LOAD_CURRENT_ITEM',
	ADJUST = 'ADJUST_QTY',
}
